import find from "lodash-es/find";
import { Component, Input, OnInit, Output } from "@angular/core";
import { DateService, MonthData } from "../../core/date.service";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "om-date-entry",
  templateUrl: "./date-entry.component.html",
  styleUrls: ["./date-entry.component.scss"],
})
export class DateEntryComponent implements OnInit {
  years: number[] = [];
  months: MonthData[];

  @Input() form: FormGroup;

  constructor(private dateService: DateService) {}

  ngOnInit() {
    this.years = this.dateService.lastXYears(10);
    this.months = this.dateService.months;
  }

  selectYear(year: number, event: Event) {
    event.preventDefault();
    this.form.controls["year"].setValue(year);
    this.months = this.dateService.pastCurrentMonthsForYear(year);
    this.invalidateFutureMonth();
  }

  invalidateFutureMonth() {
    const selectedMonth: MonthData = this.form.controls["month"].value;
    if (
      selectedMonth &&
      !find(this.months, month => month.monthNumber == selectedMonth.monthNumber)
    ) {
      this.form.controls["month"].setValue(null);
    }
  }

  selectMonth(month: MonthData, event: Event) {
    event.preventDefault();
    this.form.controls["month"].setValue(month);
  }

  get selectedYear() {
    return this.form.controls["year"].value;
  }

  get selectedMonth() {
    return this.form.controls["month"].value;
  }
}
